<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_OpenBet_Field_Server_Url')"
        prop="params.server_url"
        :hint="$t('Integrations_OpenBet_Field_Server_Url_Hint')"
      >
        <el-input v-model="model.params.server_url" placeholder="https://" />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Field_Password')"
        prop="params.password"
      >
        <el-input v-model="model.params.password" type="password" />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_OpenBet_Field_Kafka_Certificate')"
        prop="params.kafka_certificate"
      >
        <el-input
          type="textarea"
          v-model="model.params.kafka_certificate"
          :rows="10"
          id="certificate_field"
          :placeholder="
            $t('Integrations_OpenBet_Field_Certificate_Description')
          "
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_OpenBet_Field_Client_Certificate')"
        prop="params.client_certificate"
      >
        <el-input
          type="textarea"
          v-model="model.params.client_certificate"
          id="certificate_field"
          :rows="10"
          :placeholder="
            $t('Integrations_OpenBet_Field_Certificate_Description')
          "
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_OpenBet_Field_Client_Key')"
        prop="params.client_key"
      >
        <el-input
          type="textarea"
          v-model="model.params.client_key"
          :rows="10"
          id="certificate_field"
          :placeholder="$t('Integrations_OpenBet_Field_Key_Description')"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_OpenBet_Field_Cluster')"
        prop="params.cluster"
      >
        <el-select v-model="model.params.cluster" filterable style="width: 18%">
          <el-option
            v-for="(item, index) in cluster"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'OpenBetSettings',

  components: { RestFormItem, FormSection },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      cluster: [
        {
          label: 'Customer',
          value: 'CUST'
        },
        {
          label: 'Sports',
          value: 'SPORTS'
        }
      ]
    }
  },

  computed: {
    isEditPage() {
      return !!this.$route.query.id
    },
    rules() {
      return {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          server_url: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          password: [
            {
              required: !this.isEditPage,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          kafka_certificate: [
            {
              required: !this.isEditPage,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          client_certificate: [
            {
              required: !this.isEditPage,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          client_key: [
            {
              required: !this.isEditPage,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          cluster: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ]
        }
      }
    }
  }
}
</script>

<style scoped>
>>> textarea#certificate_field {
  font-family: 'Courier New', Courier, monospace !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/openbet/OpenBetSettings.vue